import {
  paymentProcessingFeeTooltip,
  renderDateCell,
  renderLinkCell,
  renderMoneyCell,
  renderPercentageCell,
  renderPriceCell,
  renderStatusCell,
  renderTransactionIdCell,
} from '../Components/Sections/Overview/renderers'

const SOLD_FOR_TOOLTIP = `This tab shows the price that the buyer paid after applying coupon code,
price offer, sales campaign discount or Customer Loyalty discount.`

const AFTER_TAX_TOOLTIP =
  'Earnings are calculated after applying payment processing fees to the sales price.'

// Column defs consumed by the shared DataTable for the Sales tab.
// Column visibility is layered on top at render time by the Sales tab via `visible: false`.
export const regularSalesColumns = [
  { key: 'oid', header: 'OID' },
  { key: 'purchased', header: 'Date', minWidth: '100px', cell: renderDateCell },
  { key: 'product', header: 'Product', width: '200px', cell: renderLinkCell },
  { key: 'buyer', header: 'Buyer', cell: renderLinkCell },
  { key: 'country', header: 'Country' },
  { key: 'originalPrice', header: 'Original price', cell: renderMoneyCell },
  {
    key: 'soldFor',
    header: 'Sold for',
    tooltip: SOLD_FOR_TOOLTIP,
    cell: renderMoneyCell,
  },
  {
    key: 'payoutCalculationPrice',
    header: 'Price for payout calculation',
    width: '120px',
    cell: renderMoneyCell,
  },
  {
    key: 'paymentProcessingFee',
    header: 'Payment processing fee',
    tooltip: paymentProcessingFeeTooltip,
    width: '120px',
    cell: renderMoneyCell,
  },
  {
    key: 'afterTax',
    header: 'After payment processing fee',
    tooltip: AFTER_TAX_TOOLTIP,
    width: '140px',
    cell: renderMoneyCell,
  },
  { key: 'earningRate', header: 'Payout rate', cell: renderPercentageCell },
  { key: 'donationRate', header: 'Donation rate', cell: renderPercentageCell },
  { key: 'donationValue', header: 'Donation amount', cell: renderMoneyCell },
  { key: 'finalPayout', header: 'Final earnings', cell: renderMoneyCell },
  {
    key: 'payoutStatus',
    header: 'Status',
    accessor: (row) => row.payoutTransactionId,
    cell: renderStatusCell,
  },
  { key: 'payoutTransactionId', header: 'Transaction ID', cell: renderTransactionIdCell },
]

// Flat list consumed by the ColumnVisibilityMenu. Per design, only these
// columns can be toggled — the rest (OID, Date, Product, Buyer, Price for
// payout calculation, Final earnings) are always visible in the table and
// therefore not surfaced in the menu.
export const regularSalesMenuColumns = [
  { key: 'country', label: 'Country' },
  { key: 'originalPrice', label: 'Original price' },
  { key: 'soldFor', label: 'Sold for' },
  { key: 'paymentProcessingFee', label: 'Payment processing' },
  { key: 'afterTax', label: 'After tax' },
  { key: 'earningRate', label: 'Earning rate' },
  { key: 'payoutTransactionId', label: 'Transaction ID' },
  { key: 'donationRate', label: 'Donation rate' },
  { key: 'donationValue', label: 'Donation amount' },
]

export const regularDownloadsColumns = [
  { key: 'productId', header: 'Product ID' },
  { key: 'downloadDate', header: 'Date', minWidth: '100px', cell: renderDateCell },
  { key: 'product', header: 'Product', cell: renderLinkCell },
  { key: 'downloader', header: 'Downloader', cell: renderLinkCell },
  { key: 'price', header: 'Price', cell: renderPriceCell },
  { key: 'fileName', header: 'File Name' },
]
